export const pause = delay => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, delay.millis);
    });
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param function function Function to invoke
 * @param wait time in ms to wait.
 * @param immediate boolean trigger the function on the leading edge, instead of the trailing.
 * @returns function
 */

export const debounce = (func, wait, immediate) => {
    let timeout;
    const debounced = (...args) => {
        const context = this;
        const later = () => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };

    debounced.cancel = () => {
        clearTimeout(timeout);
        timeout = null;
    };

    return debounced;
};
